var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import Anchor from '@telia-front/anchor';
import Badge from '@telia-front/badge';
import { useIsMounted } from '@telia-front/helper';
import Icon from '@telia-front/icon';
import { default as HeaderDropdown } from '../header-dropdown/header-dropdown';
export const HeaderActionsItem = React.memo((props) => {
    const { closeLabel, dropdownContainer, dropdownContent, dropdownContentRef, dropdownFooter, dropdownHeader, dropdownOffsetY, dropdownPadding = 'small', dropdownSize = 'small', hideLabel = false, id, icon, isCurrent = false, isCurrentAnimating = false, isPlaceholder, label, labelClassName, location, onDropdownClose, onDropdownTransitionExited, onToggle, showArrow, badge, asModal, showOverlay } = props, rest = __rest(props, ["closeLabel", "dropdownContainer", "dropdownContent", "dropdownContentRef", "dropdownFooter", "dropdownHeader", "dropdownOffsetY", "dropdownPadding", "dropdownSize", "hideLabel", "id", "icon", "isCurrent", "isCurrentAnimating", "isPlaceholder", "label", "labelClassName", "location", "onDropdownClose", "onDropdownTransitionExited", "onToggle", "showArrow", "badge", "asModal", "showOverlay"]);
    const isMounted = useIsMounted();
    const anchorElement = React.useRef(null);
    const labelBEM = () => {
        const classArray = ['header__actions-label'];
        if (labelClassName) {
            classArray.push(labelClassName);
        }
        return classArray.join(' ');
    };
    const buttonBEM = () => {
        const classArray = ['header__actions-button', `header__actions-button--${id}`];
        if (hideLabel) {
            classArray.push('header__actions-button--hide-label');
        }
        if (isCurrentAnimating) {
            classArray.push('is-current');
        }
        return classArray.join(' ');
    };
    const BEM = () => {
        const classArray = ['header__actions-item', `header__actions-item--${id}`, `header__actions-item--${location}`];
        if (isPlaceholder) {
            classArray.push('header__actions-item--placeholder');
        }
        return classArray.join(' ');
    };
    const handleKeyDown = (event) => {
        if (dropdownContent) {
            switch (event.key) {
                case 'Enter':
                case ' ': {
                    // toggle dropdown visiblity with enter and space
                    event.preventDefault();
                    if (onToggle) {
                        onToggle(!isCurrent);
                    }
                    break;
                }
                case 'Escape': {
                    // escaping, should close dropdown
                    event.preventDefault();
                    if (onToggle) {
                        onToggle(false);
                    }
                    break;
                }
            }
        }
    };
    return (React.createElement("li", { className: BEM() },
        React.createElement(Anchor, Object.assign({ isUnderlined: false }, rest, { className: buttonBEM(), elementRef: anchorElement, "aria-controls": isMounted && dropdownContent && isCurrent ? `header-${id}-dropdown` : undefined, role: isMounted && dropdownContent ? 'button' : undefined, attributes: {
                'aria-expanded': isMounted && dropdownContent ? (isCurrent ? 'true' : 'false') : undefined,
                onKeyDown: handleKeyDown,
            } }),
            React.createElement("div", { className: "header__actions-button-inner" },
                React.createElement("div", { className: "header__actions-icon-wrapper" },
                    icon && React.createElement(Icon, { modifiers: icon, className: "header__actions-icon" }),
                    React.createElement(Icon, { modifiers: "#close", className: "header__actions-icon header__actions-icon--close" }),
                    (badge === null || badge === void 0 ? void 0 : badge.text) && React.createElement(Badge, { text: badge.text, purpose: badge.purpose, className: "header__actions-badge", size: "small" })),
                React.createElement("span", { className: labelBEM() }, closeLabel && isCurrent ? closeLabel : label),
                showArrow && React.createElement(Icon, { modifiers: "#arrow-down", className: "header__actions-arrow" }))),
        dropdownContent && dropdownContainer && (React.createElement(HeaderDropdown, { offsetY: dropdownOffsetY || (location === 'bottom' ? 10 : 0), size: dropdownSize, padding: dropdownPadding, onClose: onDropdownClose, reference: anchorElement.current, container: dropdownContainer, isShown: isCurrent, onTransitionExited: onDropdownTransitionExited, header: dropdownHeader, footer: dropdownFooter, contentRef: dropdownContentRef, id: `header-${id}-dropdown`, asModal: asModal, className: `header__dropdown--${id}` }, dropdownContent))));
});
